module.exports = __webpack_public_path__ + "img/automobilism.002d77d2.png";